import { useState } from 'react';
import { Vehicle } from '../types';
import { cn } from '@/shadcn-ui/utils';
import { useInView } from 'react-intersection-observer';
import { AspectRatio } from '@/shadcn-ui/aspect-ratio';

interface VehicleTileAnimatedImagesProps {
  vehicle: Vehicle;
  PUBLIC_CDN_URL: string;
}

export default function VehicleTileAnimatedImages({
  vehicle,
  PUBLIC_CDN_URL,
}: VehicleTileAnimatedImagesProps) {
  const thumbnail_image_url = vehicle.thumbnail_image?.path
    ? `${PUBLIC_CDN_URL}/${vehicle.thumbnail_image.path}.webp`
    : undefined;

  const passenger_image_url = vehicle.passenger_image?.path
    ? `${PUBLIC_CDN_URL}/${vehicle.passenger_image.path}.webp`
    : undefined;

  const isPassengerImagePresent = passenger_image_url !== undefined;

  const [isHovering, setIsHovering] = useState(false);

  const { ref, inView } = useInView({
    triggerOnce: true,
  });

  return (
    <AspectRatio
      ratio={4 / 3}
      ref={ref}
      onMouseEnter={() => setIsHovering(isPassengerImagePresent)}
      onMouseLeave={() => setIsHovering(false)}
      className="relative w-full overflow-hidden"
    >
      <img
        src={thumbnail_image_url}
        alt={`${vehicle.make} ${vehicle.model}`}
        style={{
          willChange: 'opacity',
        }}
        className={cn(
          'absolute scale-118 overflow-hidden opacity-100 transition-opacity duration-300 ease-in-out',
          {
            'opacity-0': isHovering,
          }
        )}
      />

      {inView && passenger_image_url ? (
        <img
          src={passenger_image_url}
          alt={`${vehicle.make} ${vehicle.model}`}
          style={{
            willChange: 'opacity',
          }}
          className={cn(
            'absolute overflow-hidden opacity-0 transition-opacity duration-300 ease-in-out',
            {
              'opacity-100': isHovering,
            }
          )}
        />
      ) : null}
    </AspectRatio>
  );
}
